module.exports = __webpack_public_path__ + "static/media/serigrafia_icon.56e36ff8.svg";